import { status } from 'skin/event/status'

const next = (obj, ms, story, data, d, action) => {
    return status.action
}

export default next